import React from "react";
import "../styles/stepIndicator.css";

const StepIndicator = ({ steps, currentStep }) => {
  return (
    <div className="step-indicator-horizontal">
      {/* Linha antes da primeira bolinha */}
      <div className="step-line initial-line" />

      {steps.map((_, index) => {
        const isCompleted = index < currentStep - 1;
        const isCurrent = index === currentStep - 1;

        return (
          <div key={index} className="step-wrapper">
            <div
              className={`step-circle ${
                isCompleted ? "completed" : isCurrent ? "current" : ""
              }`}
            />
            {index < steps.length - 1 && (
              <div className={`step-line ${isCompleted ? "completed" : ""}`} />
            )}
          </div>
        );
      })}
    </div>
  );
};

export default StepIndicator;
